export const FETCH_NOT_STARTED_PHOTO_SESSIONS = 'FETCH_NOT_STARTED_PHOTO_SESSIONS';
export const FETCH_STARTED_PHOTO_SESSIONS = 'FETCH_STARTED_PHOTO_SESSIONS';
export const PHOTO_SESSIONS_LIST_PAGE_VIEWED_ANALYTICS = 'PHOTO_SESSIONS_LIST_PAGE_VIEWED_ANALYTICS';
export const PHOTO_SESSIONS_LIST_CLICKED_ANALYTICS = 'PHOTO_SESSIONS_LIST_CLICKED_ANALYTICS';
